module.exports = __webpack_public_path__ + "img/ly.d88ce172.svg";